'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultValidators = exports.exactMatch = exports.pattern = exports.length = exports.boolean = exports.email = exports.required = exports.useValue = exports.validator = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.createValidators = createValidators;
exports.normalizeValidators = normalizeValidators;
exports.validate = validate;
exports.selectValidators = selectValidators;
exports.combinedValidators = combinedValidators;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _isBoolean = require('validator/lib/isBoolean');

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _isEmail = require('validator/lib/isEmail');

var _isEmail2 = _interopRequireDefault(_isEmail);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isLength = require('validator/lib/isLength');

var _isLength2 = _interopRequireDefault(_isLength);

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _matches = require('validator/lib/matches');

var _matches2 = _interopRequireDefault(_matches);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var passthrough = function passthrough(v) {
  return v;
};

var createErrorMessage = function createErrorMessage(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return typeof message === 'function' ? message(options) : message.toString();
};

var validator = function validator(fn, defaultMessage) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _options$message = options.message,
        message = _options$message === undefined ? defaultMessage : _options$message,
        others = _objectWithoutProperties(options, ['message']);

    var error = void 0;
    try {
      error = !fn(others);
    } catch (e) {
      message = message || e.toString();
      error = e;
    }
    return Object.assign({
      error: error,
      options: options
    }, error ? {
      errorMessage: createErrorMessage(message, others)
    } : {});
  };
};

exports.validator = validator;
var useValue = exports.useValue = function useValue(fn) {
  return function (_ref) {
    var value = _ref.value;
    return fn(value);
  };
};

var required = exports.required = validator(function (_ref2) {
  var required = _ref2.required,
      value = _ref2.value;
  return !required || required && (typeof value === 'string' ? !(0, _isEmpty2['default'])(value.trim()) : !(0, _isEmpty2['default'])(value));
}, 'Please enter a value');

var email = exports.email = validator(function (_ref3) {
  var value = _ref3.value;
  return value === '' || (0, _isEmail2['default'])(value);
}, 'Please enter a valid email address');

var boolean = exports.boolean = validator(useValue(function (v) {
  return (0, _isNil2['default'])(v) ? false : (0, _isBoolean2['default'])(v.toString());
}), 'Please enter a valid boolean value');

var length = exports.length = validator(function (_ref4) {
  var value = _ref4.value,
      min = _ref4.min,
      max = _ref4.max;
  return (0, _isLength2['default'])(value, { min: min, max: max });
}, function (_ref5) {
  var min = _ref5.min,
      max = _ref5.max;
  return (0, _isNil2['default'])(min) ? 'Please enter a value with a length of ' + max + ' or less' : (0, _isNil2['default'])(max) ? 'Please enter a value with a length of ' + min + ' or more' : 'Please enter a value with a length between ' + min + ' and ' + max;
});

var pattern = exports.pattern = validator(function (_ref6) {
  var pattern = _ref6.pattern,
      value = _ref6.value;
  return (0, _isNil2['default'])(pattern) ? true : (0, _matches2['default'])(value, pattern);
}, function (_ref7) {
  var pattern = _ref7.pattern;
  return 'Must match ' + pattern.toString();
});

var exactMatch = exports.exactMatch = validator(function (_ref8) {
  var exactMatch = _ref8.exactMatch,
      _ref8$children = _ref8.children,
      children = _ref8$children === undefined ? [] : _ref8$children,
      value = _ref8.value;

  if ((0, _isNil2['default'])(exactMatch) || exactMatch === false || (0, _isEmpty2['default'])(value)) return true;

  var values = _react2['default'].Children.map(children, function (_ref9) {
    var _ref9$props = _ref9.props;
    _ref9$props = _ref9$props === undefined ? {} : _ref9$props;
    var value = _ref9$props.value;
    return value;
  }).filter(function (value) {
    return !(0, _isNil2['default'])(value);
  });

  return values.length === 0 ? true : values.indexOf(value) !== -1;
}, useValue(function (value) {
  return value + ' is not a valid entry';
}));

var defaultValidators = exports.defaultValidators = {
  boolean: boolean,
  exactMatch: exactMatch,
  email: email,
  length: length,
  pattern: pattern,
  required: required
};

function createValidators() {
  var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : passthrough;

  var validators = cb(defaultValidators);

  if (!(0, _isPlainObject2['default'])(validators)) {
    throw 'Create validator must return an Object'; // eslint-disable-line no-throw-literal
  }

  Object.keys(validators).forEach(function (k) {
    if (typeof validators[k] !== 'function') throw 'Can not create validator ' + k + ', since it is not a function.'; // eslint-disable-line no-throw-literal
  });

  return validators;
}

function normalizeValidators(validators) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return args.filter(function (v) {
    return v !== undefined;
  }).reduce(function (o, v) {
    if (typeof v === 'function') return [].concat(_toConsumableArray(o), [v]);
    if (typeof v === 'string' && !!validators[v]) return [].concat(_toConsumableArray(o), [validators[v]]);
    if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) !== 'object') throw 'Unknown validator ' + v.toString(); // eslint-disable-line no-throw-literal
    if (v instanceof Array) return [].concat(_toConsumableArray(o), _toConsumableArray(normalizeValidators.apply(undefined, [validators].concat(_toConsumableArray(v)))));
    return [].concat(_toConsumableArray(o), _toConsumableArray(normalizeValidators.apply(undefined, [validators].concat(_toConsumableArray(Object.keys(v).filter(function (k) {
      return v[k];
    }))))));
  }, []);
}

function validate(validators, props) {
  var results = validators.reduce(function (o, fn) {
    var r = fn(props);
    return r instanceof Array ? [].concat(_toConsumableArray(o), _toConsumableArray(r)) : [].concat(_toConsumableArray(o), [r]);
  }, []);
  return results.filter(function (result) {
    return result.error;
  }).map(function (result) {
    return result.errorMessage;
  });
}

function selectValidators(validators) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var results = normalizeValidators.apply(undefined, [validators].concat(args));
  return function (props) {
    return validate(results, props);
  };
}

function combinedValidators() {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var validators = normalizeValidators.apply(undefined, [{}].concat(args));
  return function (props) {
    return validators.map(function (v) {
      return v(props);
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Input/validators.js
// module id = 699
// module chunks = 32